export default {
  getHead: () => {
    return [{name: '사업장명'}, {name: '업체명'}, {name: '평가일'}, {name: '평가점수'}, {name: '소속명'}, {name: '부서명'}, {name: '작성자'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 사업장명
      case 1: return func.getContent(value).companyName // 업체명
      case 2: return func.getContent(value).stdInfo.평가일 // 평가일
      case 3: return func.getContent(value).userScore // 평가점수
      case 4: return func.getContent(value).stdInfo.department // 소속명
      case 5: return func.getContent(value).stdInfo.section ? func.getContent(value).stdInfo.section : func.getContent(value).stdInfo.com_name // 부서명
      case 6: return value.user ? value.user.name : value.author.name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.평가일) {
      nav.dateTarget = 'content$body.stdInfo."평가일"'
      nav.dateBegin = 'nav.value.평가일.sDate'
      nav.dateEnd = 'nav.value.평가일.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    switch (nav.value.searchType) {
    case '사업장명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
    case '업체명': returnData.push('content$body.companyName*%[:default_skw]%'); break
    case '평가일': returnData.push('content$body.stdInfo."평가일"*%[:default_skw]%'); break
    case '평가점수': returnData.push('content$body.userScore*%[:default_skw]%'); break
    case '소속명': returnData.push('content$body.stdInfo.department*%[:default_skw]%'); break
    case '부서명': 'content$body.stdInfo.section*%[:default_skw]%'? returnData.push('content$body.stdInfo.section*%[:default_skw]%'): returnData.push('content$body.stdInfo.com_name*%[:default_skw]%'); break
    case '작성자': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    }

    return returnData
  },
}
